// app/javascript/controllers/drag_activator_controller.js
import { Controller } from "stimulus"
import Sortable from "sortablejs"
import Rails from "@rails/ujs"

export default class extends Controller {
  connect() {
    this.initSortableCategories()
    this.initSortableMenuItems()
  }

  // -------------------- CATEGORIES --------------------
  initSortableCategories() {
    const nestedCategories = document.querySelectorAll(".nested-categories")
    nestedCategories.forEach(container => {
      if (container.sortableInstance) return

      new Sortable(container, {
        group: 'categories',
        handle: '.handle',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        forceFallback: true,
        onEnd: (event) => this.saveCategoryPosition(event)
      })
      container.sortableInstance = true
    })
  }

  saveCategoryPosition(event) {
    const item = event.item
    const dragUrl = item.dataset.dragUrl
    const id = item.dataset.id
    const targetId = event.to.dataset.id || ""
    const position = event.newIndex + 1

    if (!dragUrl || !id) return

    const data = new FormData()
    data.append("target_id", targetId)
    data.append("position", position)

    Rails.ajax({
      url: dragUrl.replace(":id", id),
      type: 'PATCH',
      data: data,
      // Rails.ajax only emits ajax:success when given an element, so the V2 save
      // bar is told about the reorder here instead.
      success: () => document.dispatchEvent(new CustomEvent("menu-v2:changed")),
    })
  }

  // -------------------- MENU ITEMS --------------------
  initSortableMenuItems() {
    const nestedMenuItems = document.querySelectorAll(".nested-menu-items")
    nestedMenuItems.forEach(tbody => {
      if (tbody.sortableInstance) return

      new Sortable(tbody, {
        group: 'menuItems',
        handle: '.handle',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        forceFallback: true,
        onEnd: (event) => this.saveMenuItemPosition(event)
      })
      tbody.sortableInstance = true
    })
  }

  saveMenuItemPosition(event) {
    const item = event.item
    const dragUrl = item.dataset.dragUrl
    const id = item.dataset.id
    const targetId = event.to.dataset.id || ""
    const position = event.newIndex + 1

    if (!dragUrl || !id) return

    const data = new FormData()
    data.append("target_id", targetId)
    data.append("position", position)

    Rails.ajax({
      url: dragUrl.replace(":id", id),
      type: 'PATCH',
      data: data,
      // Rails.ajax only emits ajax:success when given an element, so the V2 save
      // bar is told about the reorder here instead.
      success: () => document.dispatchEvent(new CustomEvent("menu-v2:changed")),
    })
  }
}